import { Platform } from 'react-native'
import * as Application from 'expo-application'

/**
 * Store iOS 1.2.0 / 1.2.1 (build 21 recovery family) fatals in Fabric while
 * mounting: RCTMountingManager + Reanimated CSS interpolators + navigation
 * transitions (TAGO-MOBILE-40 / 41 / 42 / 43 / 3Q).
 *
 * This cannot be caught in JS. The 1.2.2 binary is the native fix. JS only
 * refuses the work that trips the old descriptor: Mapbox evaluation, layout
 * entrance animations, and stack push transitions.
 */
export function isLegacyIosFabricCrashRuntime(): boolean {
  if (Platform.OS !== 'ios') return false
  const version = Application.nativeApplicationVersion ?? ''
  return version === '1.2.0' || version === '1.2.1'
}
